import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    OnInit,
    ElementRef,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    CommonLookupServiceProxy,
    DropDownLookupDto,
    CreateOrEditAddStockDto,
    FindProductOutputDto,
    TaxDto,
    Status,
    CreateOrEditAddStockDetailDto,
    GetAddStockForEditInput,
    StockAdjustmentServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { debug } from 'console';
import { forEach } from 'lodash-es';

@Component({
    templateUrl: './create-or-edit-stockadjustment.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditStockAdjustmentComponent extends AppComponentBase implements OnInit {
    @ViewChildren('itemCodeInput') itemCodeInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('qtyInput') qtyInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('costInput') costInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('focQtyInput') focQtyInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('itemDiscountPercInput') itemDiscountPercInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('itemDiscountInput') itemDiscountInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('taxInput') taxInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('addButton') addButtons!: QueryList<ElementRef<HTMLButtonElement>>;
    active = false;
    saving = false;
    products: FindProductOutputDto[];
    applicableTaxes: TaxDto[];
    units: any[] = [];

    filterText = '';
    
    stockAdjustment: CreateOrEditAddStockDto = new CreateOrEditAddStockDto();
    stockAdjustmentDetails: CreateOrEditAddStockDetailDto[];
    stockAdjustmentDetail: CreateOrEditAddStockDetailDto = new CreateOrEditAddStockDetailDto();
    vendorDisplayProperty = '';
    status = Status;
    allStockAdjustmentTypes: DropDownLookupDto[];
    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('AddStocks'), '/app/stock/addStocks'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _stockAdjustmentServiceProxy: StockAdjustmentServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,

    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
        this.addRow(0);
    }

    removeItem(index: number) {
        this.stockAdjustmentDetails.splice(index, 1);

        if (this.stockAdjustmentDetails.length == 0) {
            this.addRow(index);
        }

        var i = 1;
        this.stockAdjustmentDetails.forEach((c) => {
            c.slNo = i++;
        });
    }

    searchProduct(productCode: string, data: CreateOrEditAddStockDetailDto, index: number) {
        this._commonLookupServiceProxy
            .getProductDetail(undefined, productCode, undefined, 'Purchase', 0,this.appSession.user.locationId)
            .subscribe((result) => {
                if (result.productId > 0) {
                    this.focusNext('qty', index);
                    data.productId = result.productId;
                    data.cost = result.unitCost;
                    data.productName = result.productName;
                    data.productCode = result.productCode;
                    data.cost = result.unitCost;
                    data.price = result.price;
                    data.applicableUnits = result.applicableUnits;
                    /*  data.applicableTaxes = result.applicableTaxes;*/ 
                    data.unitId = result.unitId;
                    data.qty = 1;
                    if (data.productSelectedItem == null) {
                        data.productSelectedItem = new FindProductOutputDto();
                        data.productSelectedItem.id = data.productId;
                        data.productSelectedItem.displayName = data.productName;
                        //this.productSelectedItem.code = result.productCode;
                    }
                    this.changeUnit(data);
                } else {
                    abp.notify.error('ProductNotFound');
                    data.productCode = '';
                }
            });
    }

    focusNext(type: 'qty' | 'cost' | 'focQty' | 'itemDiscountPerc' | 'itemDiscount' | 'tax' | 'add' | 'nextRow', index: number) {
        if (type === 'qty') {
            const next = this.qtyInputs.get(index);
            next?.nativeElement.focus();
            setTimeout(() => next.nativeElement.select(), 0);
        } else if (type === 'cost') {
            const next = this.costInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'focQty') {
            const next = this.focQtyInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'itemDiscountPerc') {
            const next = this.itemDiscountPercInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'itemDiscount') {
            const next = this.itemDiscountInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'tax') {
            const next = this.taxInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'add') {
            const next = this.addButtons.get(index);
            next?.nativeElement.focus();
        } else if (type === 'nextRow') {
            if (index === this.stockAdjustmentDetails.length - 1) {
                this.addRow(index);
                setTimeout(() => {
                    const nextItem = this.itemCodeInputs.get(index + 1);
                    nextItem?.nativeElement.focus();
                });
            } else {
                const nextItem = this.itemCodeInputs.get(index + 1);
                nextItem?.nativeElement.focus();
            }
        }
    }

    addRow(index: number): void {
        if (this.stockAdjustmentDetails == null) this.stockAdjustmentDetails = [];

        this.stockAdjustmentDetail = new CreateOrEditAddStockDetailDto();
        this.stockAdjustmentDetail.slNo = this.stockAdjustmentDetails.length + 1;
        this.stockAdjustmentDetails.push(this.stockAdjustmentDetail);
        const nextItem = this.itemCodeInputs.get(index + 1);
        nextItem?.nativeElement.focus();
    }

    changeUnit(data: any): void {
        data.changeUnitFlag = true;
        this.fillDropDownUnitBasedOnProduct(data.productId, data);
    }

    fillDropDownUnitBasedOnProduct(selectProductId: number, data: CreateOrEditAddStockDetailDto): void {
       
        this._commonLookupServiceProxy.getUnitForProductCombobox(selectProductId).subscribe({
            next: (result: any) => {
               
                if (!(data.unitId > 0 && data.qty > 0)) {
                    data.unitId = data.unitId;
                    data.unitName = data.unitName;
                }
                this.amountCalculate(data);
                this.calculateTotalValues();
            },
            error: () => { },
        });
    }

    show(addStockId?: number): void {
        if (!addStockId) {
            this.stockAdjustment = new CreateOrEditAddStockDto();
            this.stockAdjustment.id = addStockId;
            this.stockAdjustment.stockDate = this._dateTimeService.getStartOfDay();
            this.active = true;
            this.stockAdjustment.locationId = this.appSession.user.locationId;
            this.stockAdjustment.status = Status.Draft;
        } else {
            this._stockAdjustmentServiceProxy.getStockAdjustmentForEdit(addStockId).subscribe((result) => {
                this.stockAdjustment = result.addStock;
                this.stockAdjustmentDetails = result.addStockDetails;
                this.stockAdjustmentDetails.forEach((c) => {
                    c.productSelectedItem = new FindProductOutputDto();
                    c.productSelectedItem.id = c.productId;
                    c.productSelectedItem.displayName = c.productName;
                });

                if (this._activatedRoute.snapshot.queryParams['dirinv'] == 0) {
                    this.stockAdjustment.id = null;
                    this.stockAdjustment.status = this.status.Draft;
                }
            });
        }
        
        this._commonLookupServiceProxy.getAllTaxes().subscribe((result) => {
            this.applicableTaxes = result;
        });
        this._commonLookupServiceProxy.getAllStockAdjustmentTypesForTableDropdown().subscribe((result) => {
            this.allStockAdjustmentTypes = result;
        });
    }

    getCurrencyRate(value: any): void {
        this.calculateTotalValues();
    }

    amountCalculate(data: CreateOrEditAddStockDetailDto) {
        /*var totalCost = parseFloat((qty * cost).toFixed(2));*/
        data.totalCost = parseFloat((data.cost * data.qty).toFixed(2));
        data.totalPrice = parseFloat((data.price * data.qty).toFixed(2));
        this.calculateTotalValues();
    }

    calculateTotalValues(): void {
        var data = this.stockAdjustmentDetails;
        let totalQty = 0;
        let totalCost = 0;
        let totalPrice = 0;

        this.stockAdjustmentDetails.forEach((val) => {
            totalCost = Number(totalCost) + Number(val.totalCost);
            totalPrice = Number(totalPrice) + Number(val.totalPrice);
            totalQty = Number(totalQty) + Number(val.qty);
        });

        this.stockAdjustment.totalCost = totalCost;
        this.stockAdjustment.totalPrice = totalPrice;
        this.stockAdjustment.stockQty = totalQty;
    }

    save(status: any): void {
        this.saving = true;

        this.stockAdjustment.status = status;
        var addStockInput = new GetAddStockForEditInput();
        addStockInput.addStock = this.stockAdjustment;
        addStockInput.addStockDetails = this.stockAdjustmentDetails;

        this._stockAdjustmentServiceProxy
            .createOrEdit(addStockInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.goBack();
            });
    }

    saveAndNew(status: any): void {
        this.saving = true;
        var addStockInput = new GetAddStockForEditInput();
        addStockInput.addStock = this.stockAdjustment;
        addStockInput.addStockDetails = this.stockAdjustmentDetails;
        this._stockAdjustmentServiceProxy
            .createOrEdit(addStockInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.stockAdjustment = new CreateOrEditAddStockDto();
                this.goBack();
               
            });
    }

    getProduct(product: FindProductOutputDto, data: CreateOrEditAddStockDetailDto, index: number) {
        this.stockAdjustmentDetails[index].productSelectedItem = product;
        this.searchProduct(product.code, data, index);
    }

    goBack(): void {
        this._router.navigate(['/app/stock/stockAdjustments']);
    }
}
